import { makeStyles } from "@mui/styles";

export const useStyle = makeStyles((theme) => ({
  mainGrid: {
    "&.MuiGrid-root": {
      width: "100%",
      display: "flex",
      height: "100dvh",
    },
  },
  menuGrid:{
    "&.MuiGrid-root": {
      height:'100%',
      maxHeight:'calc(100% - 56px)',
      "&::-webkit-scrollbar": {
        display: "none",
      },
      overflowY:'scroll'
    }
  },
  contentGrid: {
    "&.MuiGrid-root": {
      flex: 1,
    //   width: "95dvw",
    //   height: "100%",
      maxHeight: "100dvh",
      overflowY: "scroll",
      padding: "15px",
      "&::-webkit-scrollbar": {
        display: "none",
      },
    },
  },
  root: {
    "&.MuiGrid-root": {
      height: "100%",
      backgroundColor: "white",
      maxWidth:'52px',
      boxShadow:' 2px 0px 10px -1px rgba(158,158,158,0.25);',
      padding:5,
      position:'relative',
      zIndex:1100,
      [theme.breakpoints.down('900')]:{
        display:'none',
        maxWidth: 240,
        width:'100%',
      }
    },
  },
  openIcon:{
    "&.MuiIconButton-root": {
      position: "absolute",
      right: "-20px",
      top: "33px",
      transform: "rotate(-90deg)",
      zIndex:1900,
      // backgroundColor: '#A06EE1',
      "& .MuiSvgIcon-root": {
        color: '#A06EE1',
        fontSize: 28,
      },
      "&:hover": {
        "& .MuiSvgIcon-root": {
          color: '#A06EE1',
          fontSize: 28,
        },
      },
    },
  },
  sideGrid: {
    "&.MuiGrid-root": {
      height: "100%",
      backgroundColor: "white",
      minWidth:'240px',
      boxShadow:'2px 0px 10px -1px rgba(158,158,158,0.25);',
      padding:5,
      position:'relative',
      zIndex:1100,
      [theme.breakpoints.down('900')]:{
        display:'none'
      }
    },
  },
  accordionRoot:{
    "&.MuiAccordion-root": {
      boxShadow: "none",
      marginBottom: "4px",
      width:'100%',
      maxWidth:240,
      '&:hover':{
      boxShadow: "none",
      },
      '&:before':{
        display: 'none'
      },
      [theme.breakpoints.down('900')]:{
       maxWidth:270
      }
      
    },
  },

  accordionSummary:{
    "&.MuiAccordionSummary-root": {
      margin: "0px",
      minHeight: "auto",
      maxHeight: "40px",
      padding: "0px",
      marginInline:5,      
      "&:hover": {
        "& .MuiSvgIcon-root": {
          color: 'black',
          fontSize: 28,
          marginLeft:'10px',
        },
      },
      "&.Mui-expanded": {
        margin: "0px",
        minHeight: "auto",
        maxHeight: "40px",
        marginInlineEnd:5,
        padding: "0px",
        paddingInline:3,
        width:'100%',
      },
      "& .MuiSvgIcon-root": {
        color: 'black',
        fontSize: 28,
        marginLeft:'10px',
      },
    },
  },
  hoverAcc:{
    "&.MuiAccordionSummary-root": {
      margin: "0px",
      minHeight: "auto",
      maxHeight: "40px",
      padding: "0px",
      marginInline:5,
      "&:hover": {
        backgroundColor:'#F0F0F0',
        "& .MuiSvgIcon-root": {
          color: 'black',
          fontSize: 28,
          marginLeft:'10px',
        },
      },
      "&.Mui-expanded": {
        margin: "0px",
        minHeight: "auto",
        maxHeight: "40px",
        padding: "0px",
        paddingInline:3,
        marginInline:5,
        color: "red",
      },
      "& .MuiSvgIcon-root": {
        color: 'black',
        fontSize: 28,
        marginLeft:'10px',
      },
      "& .MuiTypography-root": {
        color: 'black',
      },
    }
  },

  active: {
    "&.MuiAccordionSummary-root": {
      minHeight: "auto",
      maxHeight: "40px",
      padding: "0px",
      paddingInlineEnd: "0px",
      backgroundColor:'#F0F0F0',
      color: "black",
      marginInline:5,
      "&.Mui-expanded": {
        margin: "0px",
        minHeight: "auto",
        maxHeight: "40px",
        padding: "0px",
        marginInline:5,
        // border:'1px solid light gray',
      },
      "& .MuiSvgIcon-root": {
        color: 'black',
        fontSize: 28,
        marginLeft:'10px',
      },
      "& .MuiTypography-root": {
        color: 'black',
      },
    },
  },
  subMenuGrid:{
    '&.MuiGrid-root':{
  display :'flex',
  alignItems:'center',
  padding:4,
  marginBottom:3,
  borderRadius:5,
  '&:hover' :{
    backgroundColor:'#F0F0F0',
  }
    }
  },
  subMenuActiveGrid:{
    '&.MuiGrid-root':{  
      display :'flex',
      alignItems:'center',
      boxShadow:'0px 2px 6px 0px rgba(115,103,240,.48)',
      background:'linear-gradient(72.47deg, #7367f0 22.16%, rgba(115, 103, 240, 0.7) 76.47%);',
      color:'white',
      padding:4,
      marginBottom:3,
      borderRadius:5,
      "& .MuiSvgIcon-root": {
        color: 'white',
        fontSize: 10,
        borderRadius:30
      },
    }
  }
}));
